import { render } from "./ny-system-users-password-form.vue?vue&type=template&id=660eccd0&scoped=true"
import script from "./ny-system-users-password-form.vue?vue&type=script&lang=js"
export * from "./ny-system-users-password-form.vue?vue&type=script&lang=js"

import "./ny-system-users-password-form.vue?vue&type=style&index=0&id=660eccd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660eccd0"]])

export default __exports__